import MessageHelper from '../../helpers/message-helper';

export default class TireWarrantyFileInput {

  static readonly FILE_CONTAINER_SELECTOR: string = '.js-tireWarrantyFileInputsContainer';
  private readonly FILE_WRAPPER_SELECTOR: string = '.js-fileInputWrapper';
  private readonly CLEAR_SELECTOR: string = '.js-clearFile';
  private readonly INPUT_SELECTOR: string = '.js-fileInput';
  private readonly FILE_LABEL_SELECTOR: string = '.js-fileLabel';
  private readonly LABEL_TEXT_SELECTOR: string = '.js-labelText';

  private readonly labelVal: string = `<i class="fas fa-file-upload text-primary mr-5"></i>${MessageHelper.getMessage('input.file.empty.label')}`;

  private readonly accept: string;
  private readonly fileSize: string;
  private readonly required: string;
  private readonly name: string;
  private readonly id: string;

  private idIncremental = 0;

  constructor(private container: JQuery) {

    this.accept = this.container.data('accept');
    this.fileSize = this.container.data('file-size');
    this.required = this.container.data('required');
    this.name = this.container.data('name');
    this.id = this.container.data('id');

    this.bindInputChange();
    this.bindInputClear();

    // Generate empty file input so the user can input something
    this.container.append(this.generateEmptyFileInput());
  }

  private bindInputChange(): void {
    this.container.on('change', this.INPUT_SELECTOR, (e): void => {

      const input = e.target as HTMLInputElement;
      const fileWrapper = $(input).closest(this.FILE_WRAPPER_SELECTOR);
      const fileName = input.value ? input.files![0].name : '';

      fileWrapper.find(this.LABEL_TEXT_SELECTOR).html(fileName || this.labelVal);

      fileWrapper.removeClass('-empty');
      fileWrapper.addClass('-filled');

      fileWrapper.find(this.CLEAR_SELECTOR).removeClass('d-none');
      fileWrapper.find(this.CLEAR_SELECTOR).addClass('-clickable');

      fileWrapper.find(this.FILE_LABEL_SELECTOR).addClass('-not-clickable');

      // Generate name for when the values get submitted to the backend
      $(input).attr('name', this.generateName());

      // Generate new empty file input after the user has chosen a file
      const emptyFileInput = $(this.generateEmptyFileInput());

      // Append it to the container
      this.container.append(emptyFileInput);

      // Animate it's display
      emptyFileInput
        .animate({ 'margin-top': '-34px', opacity: 0 }, 0)
        .animate({ 'margin-top': '0', opacity: 1 }, 200);

      // Trigger the event that validates maxNumberOfFiles on tyre warranty
      $(document).trigger('tireWarrantyFileAdded');
    });
  }

  private bindInputClear(): void {
    this.container.on('click', '.js-clearFile', (e): void => {

      const input = $(e.target);

      // Animate the file input chosen to be removed
      input.closest(this.FILE_WRAPPER_SELECTOR)
        .animate({ 'margin-top': '-34px', opacity: 0 }, 200, (): void => {

          // Remove the file from DOM
          input.closest(this.FILE_WRAPPER_SELECTOR).remove();

          // Trigger the event that validates maxNumberOfFiles on tyre warranty
          $(document).trigger('tireWarrantyFileRemoved');

          // Set required attribute if it's the only input in the group left
          if (this.getInputAmount() === 1 && this.required) {
            this.container.find(this.INPUT_SELECTOR).prop('required', 'true');
          }
        });
    });
  }

  private generateIncrementalId(): string {
    const newId = this.idIncremental;
    this.idIncremental += 1;
    return `${this.id}-${newId}`;
  }

  private generateName(): string {
    return `${this.name}[${this.getInputAmount()}]`;
  }

  private getInputAmount(): number {
    return this.container.find(this.FILE_WRAPPER_SELECTOR).length;
  }

  private generateValidations(): string {

    let validations = '';

    if (this.accept) {
      validations += `accept="${this.accept}"`;
    }

    if (this.fileSize) {
      validations += `data-parsley-filesize="${this.fileSize}"`;
    }

    if (this.required && this.getInputAmount() === 0) {
      validations += 'required';
    }

    return validations;
  }

  private generateEmptyFileInput(): string {

    const id = this.generateIncrementalId();

    return `
            <div class="js-fileInputWrapper -empty mb-10">
                <input id="${id}" type="file" class="js-fileInput file-input" ${this.generateValidations()}>
                <label class="file-input__label js-fileLabel" for="${id}">
                    <span class="js-labelText label-text">
                        <i class="fas fa-file-upload file-input__icon color-primary mr-5"></i>${MessageHelper.getMessage('input.file.empty.label')}
                    </span>
                    <button class="file-input__clear js-clearFile d-none" type="button">
                        <i class="fas fa-times"></i>
                    </button>
                </label>
            </div>
        `;
  }

  static initAll(): void {
    $(this.FILE_CONTAINER_SELECTOR).map((i, el) => new TireWarrantyFileInput($(el)));
  }

}
